import { FC } from 'react'

import styles from './TankIntro.module.css'

import { toRoman } from '../utils/tankTiers'
import { toNation } from './../utils/tankNations'
import { toType } from './../utils/tankTypes'

// import { TankInfo } from '../typesStuff/Tank'

import { GQLTank } from './AddTankComponents/SelectTankList'
import { TankTypeSlug } from './../utils/tankTypes'


const TankIntro: FC<{ tank: GQLTank }> = ({ tank: tankEhOhhhhh }) => {
    if (!tankEhOhhhhh) return <div>Missing tank data... 😱</div>

    return (
        <div className={styles.cell}>

            <img
                className={styles.tankImage}
                src={tankEhOhhhhh.image_preview_url}
                alt={`${tankEhOhhhhh.user_string} preview`}
            />

            <div className={styles.textWrap}>
                <span className={`${styles.name}${tankEhOhhhhh.is_premium? ` ${styles.premiumTextColour}` : ''}`}>{tankEhOhhhhh.user_string}</span>
                <span>{toType(tankEhOhhhhh.type_slug as TankTypeSlug)}</span>
                <span>{toNation(tankEhOhhhhh.nation)} | {toRoman(tankEhOhhhhh.level)}</span>
            </div>

        </div>
    )
}

export {
    TankIntro
}
